import React, { Component } from "react";
import BootstrapTable from "react-bootstrap-table-next";
import paginationFactory from "react-bootstrap-table2-paginator";
import ToolkitProvider, {
  Search,
} from "react-bootstrap-table2-toolkit/dist/react-bootstrap-table2-toolkit";
import { Dropdown, Row, Col, Button, OverlayTrigger, Tooltip } from "react-bootstrap";
import { FiPlusCircle, FiTrash2, FiEdit3, FiImage, FiEye } from "react-icons/fi";
import {
  FaRegFilePdf,
  FaRegImage,
  FaRegFileExcel,
  FaRegFileWord,
  FaRegTrashAlt,
  FaPen,
  FaEye,
  FaCheck,
  FaTimes,
} from "react-icons/fa";
import { Link } from "react-router-dom";
import { optionMasterService } from "app/_services/OptionMasterService/optionMasterService";
import { ProjectService } from "app/_services/ProjectService/ProjectService";
import { confirmAlert } from "react-confirm-alert"; // Import
import "react-confirm-alert/src/react-confirm-alert.css"; // Import css
import TableExport from "app/views/custom/components/Export/TableExport";
import { StateService } from "app/_services/ConfigService/StateService/StateService";
import ApproveReject from "app/views/custom/components/ApproveReject/ApproveReject";
import toastr from "toastr";
import { SetGlobalPermission } from "app/Components/SetPermission/Permissions";
import LogHistory from "app/views/custom/components/Logs/LogHistory";
import LastLog from "app/views/custom/components/Logs/LastLog";
import MainBreadcrumb from "app/views/custom/components/MainBreadcrumb";
import SearchBootstrapTable from "app/Components/BootstrapTable/SearchBootstrapTable";

class State extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      stateData: [],
      // projectData: {},
      // projectId: this.props.match.params.projectId ? this.props.match.params.projectId : null
    };
  }

  componentDidMount() {
    this.setStateData();
    // this.setProjectDetails();
  }

  // async setProjectDetails() {
  //     let response = await ProjectService.projectDetailsByID(this.state.projectId);

  //     if (response && response.status) {
  //         if (response.data && response.data) {
  //             this.setState({
  //                 projectData: response.data
  //             })
  //         }
  //     }
  // }

  setStateData = async () => {
    let response = await StateService.getStateAll(this.state.projectId);

    if (response && response.status) {
      if (response.data && response.data.stateMaster) {
        this.setState(
          {
            stateData: response.data.stateMaster,
          },
          () => {
            let data = JSON.parse(JSON.stringify(this.state.stateData));
            Array.isArray(data) &&
              data.map((rowData, rowindex) => {
                rowData["sid"] = rowindex + 1;
              });
            this.setState({
              stateData: data,
            });
          }
        );
      }
    } else {
      this.setState({
        stateData: [],
      });
    }
  };

  delete(e, projectId, id) {
    e.preventDefault();

    confirmAlert({
      title: "Delete State",
      message: "Do you want to proceed?",
      buttons: [
        {
          label: "Yes",
          onClick: async () => {
            let response = await StateService.deleteState(projectId, id);

            if (response && response.status) {
              toastr.info(response.message || "State Deleted!");
              this.setStateData();
            }
          },
        },
        {
          label: "No",
          onClick: () => console.log("test"),
        },
      ],
    });
  }

  tableToolbarView = () => {
    return (
      <SetGlobalPermission
        permission="global_globalConfiguration_add"
        data={
          <OverlayTrigger
            placement="top"
            overlay={<Tooltip id="tooltip-top">Add State</Tooltip>}
          >
            <Link
              className="icons btn-icon font-20 text-cyanBlue"
              to={"/global-configuration/project-details/state/add"}
            >
              <FiPlusCircle />
            </Link>
          </OverlayTrigger>
        }
      />
    );
  };

  render() {
    let { stateData, projectData, projectId } = this.state;
    let { SearchBar } = Search;
    let sortableColumn = [
      {
        dataField: "sid",
        text: "S.No.",
        sort: true,
      },
      {
        dataField: "country_master.name",
        text: "Country",
        sort: true,
      },
      {
        dataField: "name",
        text: "State",
        sort: true,
      },
      {
        dataField: "activeStatus",
        text: "Status",
        sort: true,
        formatter: (rowContent, row, index) => {
          let activeStatus = "";
          if (row.activeStatus === 1) {
            activeStatus = "Active";
          } else if (row.activeStatus === 2) {
            activeStatus = "In-Active";
          }
          return activeStatus;
        },
      },
      {
        dataField: "create",
        text: "Action",
        formatter: (rowContent, row) => {
          console.log("row", this);
          return (
            <div className="actionIconsGroup">
              <SetGlobalPermission
                permission={"configuration_ProjectDetails_view"}
                data={
                  <OverlayTrigger
                    placement="top"
                    overlay={<Tooltip id="tooltip-top">View</Tooltip>}
                  >
                    <Link
                      to={"/global-configuration/project-details/state/view/" + row.id}
                      className="icons text-cyanBlue"
                    >
                      <FiEye />
                    </Link>
                  </OverlayTrigger>
                }
              ></SetGlobalPermission>

              <SetGlobalPermission
                permission={
                  row.status == 1
                    ? "global_globalConfiguration_editAfterApprove"
                    : "global_globalConfiguration_edit"
                }
                data={
                  <OverlayTrigger
                    placement="top"
                    overlay={<Tooltip id="tooltip-top">Edit</Tooltip>}
                  >
                    <Link
                      to={"/global-configuration/project-details/state/edit/" + row.id}
                      className="icons text-cyanBlue"
                    >
                      <FiEdit3 />
                    </Link>
                  </OverlayTrigger>
                }
              ></SetGlobalPermission>

              {row.status == 1 ? (
                <SetGlobalPermission
                  permission="global_globalConfiguration_approve"
                  data={
                    <SetGlobalPermission
                      permission="global_globalConfiguration_delete"
                      data={
                        <OverlayTrigger
                          placement="top"
                          overlay={<Tooltip id="tooltip-top">Delete</Tooltip>}
                        >
                          <a
                            href="#"
                            className="icons text-danger"
                            onClick={(e) => this.delete(e, row.projectId, row.id)}
                          >
                            <FaRegTrashAlt />
                          </a>
                        </OverlayTrigger>
                      }
                    ></SetGlobalPermission>
                  }
                />
              ) : (
                <SetGlobalPermission
                  permission="global_globalConfiguration_delete"
                  data={
                    <OverlayTrigger
                      placement="top"
                      overlay={<Tooltip id="tooltip-top">Delete</Tooltip>}
                    >
                      <a
                        href="#"
                        className="icons text-danger"
                        onClick={(e) => this.delete(e, row.projectId, row.id)}
                      >
                        <FaRegTrashAlt />
                      </a>
                    </OverlayTrigger>
                  }
                ></SetGlobalPermission>
              )}

              <ApproveReject
                projectId={row.projectId}
                rowId={row.id}
                tableName={"state_master"}
                setData={this.setStateData}
                status={row.status}
                permission="global_globalConfiguration_approve"
                global
              ></ApproveReject>
            </div>
          );
        },
      },
    ];

    let paginationOptions = {
      // custom: true,
      paginationSize: 5,
      pageStartIndex: 1,
      firstPageText: "First",
      prePageText: "Back",
      nextPageText: "Next",
      lastPageText: "Last",
      nextPageTitle: "First page",
      prePageTitle: "Pre page",
      firstPageTitle: "Next page",
      lastPageTitle: "Last page",
      showTotal: true,
      totalSize: stateData.length,
    };

    return (
      <div>
        <MainBreadcrumb
          routeSegments={[
            // { name: this.state.projectData.name ? this.state.projectData.name : '', path: "/project/" + this.state.projectId + "/dashboard" },
            { name: "Global Settings", path: "#" },
            { name: "State" },
          ]}
          // imageSrc={projectData && projectData.document && projectData.document.document_name ? projectData.document.document_name : ''}
          // description={projectData && projectData.descriptionDisplay ? projectData.descriptionDisplay : ''}
          breadCrumbsText="Configuration_Project_Details_State"
        />
        <div className="card p-4 mb-4">
          {/* <ToolkitProvider
                        striped
                        keyField="id"
                        data={stateData}
                        columns={sortableColumn}
                        search={{
                            searchFormatted: true
                        }}
                    >
                        {props => (
                            <>
                                <div className="d-flex align-items-center justify-content-between pb-3">
                                    <SearchBar {...props.searchProps} className="mb-0" />
                                    <div className="btn-toolbar">
                                        <SetGlobalPermission
                                            permission="global_globalConfiguration_add"
                                            data={<OverlayTrigger placement="top"
                                                overlay={
                                                    <Tooltip id="tooltip-top">Add State</Tooltip>
                                                }
                                            >
                                                <Link
                                                    className="icons btn-icon font-20 text-cyanBlue"
                                                    to={"/global-configuration/project-details/state/add"}>
                                                    <FiPlusCircle />
                                                </Link>
                                            </OverlayTrigger>}></SetGlobalPermission>


                                        <SetGlobalPermission
                                            permission="global_globalConfiguration_download"
                                            data={<TableExport
                                                tableName={'State'}
                                                dataColumn={sortableColumn}
                                                renderData={stateData}
                                                searchText={props.searchProps.searchText}
                                            ></TableExport>}></SetGlobalPermission>


                                    </div>
                                </div>
                                <BootstrapTable
                                    {...props.baseProps}
                                    bootstrap4
                                    pagination={paginationFactory(paginationOptions)}
                                    noDataIndication={"Table is empty"}
                                />
                            </>
                        )}
                    </ToolkitProvider> */}
          <SearchBootstrapTable
            data={stateData}
            columns={sortableColumn}
            tableToolbarView={this.tableToolbarView}
            downloadPermission={"global_globalConfiguration_download"}
          />
        </div>
        <LastLog
          subModulename={"state-master"}
          // projectId={projectId}
        ></LastLog>
      </div>
    );
  }
}

export default State;
